import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import MainContent from "./MainContent";
import TableView from "./TableView";
import DataView from "./DataView";
import ChatInterface from './ChatInterface';
import FileExplorer from './FileExplorer';
import "../styles/MainApp.css";
import { useAuth } from "react-oidc-context";

const MainApp = () => {
  const [view, setView] = useState("upload");

  const auth = useAuth();
  const userId = auth.user?.profile?.sub;

  return (
    <div className="main-app">
      {/* 1) Sidebar primero: columna izquierda del grid */}
      <Sidebar setView={setView} />

      {/* 2) Columna derecha */}
      <div className="content-container">
        {/* Topbar sticky dentro del main */}
        <Topbar />

        {/* 3) Área scrolleable real */}
        <div className="page-content">
          {view === "upload" && <MainContent />}
          {view === "viewFiles" && <TableView userId={userId} />}
          {view === "data" && <DataView />}
          {view === "chatInterface" && <ChatInterface />}
          {view === "FileExplorer" && <FileExplorer userId={userId} />}
        </div>
      </div>
    </div>
  );
};

export default MainApp;
